import './CoralDomainFlipCard.scss'
import '../FlipCard.scss'

import { Asset } from '@websrc/App/Components/Asset/Asset'
import { mapCoralWebDomainFlipCard } from '@websrc/DataMappers/mapSpot'
import React, { useState } from 'react'

import { FlipCard } from '../FlipCard'
type CoralDomainFlipCardProps = ReturnType<typeof mapCoralWebDomainFlipCard> & {
  animationStartTime: number
}
export const CoralDomainFlipCard = (props: CoralDomainFlipCardProps) => {
  const [pausedVideo, setPausedVideo] = useState(true)
  const [resetOnPause, setResetOnPause] = useState(true)

  const handleHoverChange = (hovered: boolean) => {
    setPausedVideo(!hovered)
  }
  const handleFlipStart = () => {
    setResetOnPause(false)
    setPausedVideo(true)
  }

  const handleFlipEnd = (delayDone: boolean, isHovering: boolean) => {
    setResetOnPause(true)
    if (delayDone && isHovering) {
      setPausedVideo(false)
    }
  }

  const content = {
    frontHeader: (
      <div className={'coral-domain-flip-card__headline-container'}>
        <div className={'coral-domain-flip-card__headline'}>{props.header}</div>
        <div className={'coral-domain-flip-card__front-description'}>{props.front_description}</div>
      </div>
    ),
    frontContent: (
      <div className={`coral-domain-flip-card__front-image-container`}>
        <Asset
          altText={props.asset?.altText}
          animationClassName={`coral-domain-flip-card__front-image`}
          defaultTime={props.animationStartTime}
          forcePauseVideo={pausedVideo}
          lazyLoading={true}
          loopAnimation={true}
          objectFit={'cover'}
          resetOnPause={resetOnPause}
          video={props.asset?.video}
        />
      </div>
    ),
    backHeader: (
      <div className={'coral-domain-flip-card__headline-container'}>
        <div className={'coral-domain-flip-card__headline'}>{props.header}</div>
        <div className={'coral-domain-flip-card__back-description'}>{props.back_description}</div>
      </div>
    ),
    backContent: (
      <div className={'coral-domain-flip-card__back-content'}>
        {props.badges_group.map((group, groupId) => (
          <div className={'coral-domain-flip-card__back-content-wrapper'} key={groupId}>
            <div className={'coral-domain-flip-card__badge-title'}>{group.badges_title}</div>
            <div className={'coral-domain-flip-card__badge'}>
              {group.badges.map((badge, badgeId) => (
                <div key={badgeId}>
                  <span className={`coral-domain-flip-card__badge-name m--${group.visuals}`}>
                    {badge}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    ),
  }

  return (
    <FlipCard
      animateFixedMobile={400}
      animateFixedTablet={'auto'}
      animateHeight={true}
      buttonColor={props.button_visuals}
      className={'coral-domain-flip-card'}
      content={content}
      onFlipEndChange={handleFlipEnd}
      onFlipStartChange={handleFlipStart}
      onHoverChange={handleHoverChange}
      unhoverOnClick={true}
    />
  )
}
